import React from 'react';
import BrutalistNavbar from '../components/layout/BrutalistNavbar';
import BrutalistFooter from '../components/layout/BrutalistFooter';
import BrutalistHero from '../components/home/BrutalistHero';
import BrutalistFeatures from '../components/home/BrutalistFeatures';
import BrutalistPhilosophy from '../components/home/BrutalistPhilosophy';
import BrutalistProtocol from '../components/home/BrutalistProtocol';
import BrutalistPricing from '../components/home/BrutalistPricing';
import BrutalistContact from '../components/home/BrutalistContact';
import BrutalistReviews from '../components/home/BrutalistReviews';
import { Toaster } from '../components/ui/toaster';
import ScrollToTop from '../components/ui/ScrollToTop';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground font-sans selection:bg-accent selection:text-white">
      <BrutalistNavbar />
      <main>
        <BrutalistHero />
        <BrutalistFeatures />
        <BrutalistPhilosophy />
        <BrutalistProtocol />
        <BrutalistPricing />
        <BrutalistReviews />
        <BrutalistContact />
      </main>
      <BrutalistFooter />
      <Toaster />
      <ScrollToTop />
    </div>
  );
};

export default HomePage;
